// @flow
import React from 'react';
import classNames from 'classnames';
import { get } from 'lodash';
import { Icon } from '@elements';

// Each plan lists what it adds on top of the one below it.
const PLAN_FEATURES = {
  basic: ['agenda_records', 'one_professional', 'chat_email_support'],
  complete: ['everything_in_basic', 'e_prescriptions', 'forms', 'financial', 'storage_20gb'],
  concierge: ['everything_in_complete', 'custom_forms', 'multiple_clinics', 'storage_100gb', 'priority_support'],
};

type PriceProps = {
  plan: Object,
  small?: boolean,
  _: Function,
};

// 79 -> "79", 79.9 -> "79,90"
export const formatPlanAmount = (plan: Object): string => {
  const value = Number(get(plan, 'price', 0));
  return Number.isInteger(value) ? String(value) : value.toFixed(2).replace('.', ',');
};

export const PlanPrice = ({ plan, small, _ }: PriceProps) => {
  const amount = formatPlanAmount(plan);

  return (
    <span className={classNames('planPrice', { small })}>
      <span className="currency">{get(plan, 'currencySymbol')}</span>
      <span className="amount">{amount}</span>
      <span className="period">{_('label/per_month')}</span>
    </span>
  );
};

type FeaturesProps = {
  type: string,
  _: Function,
};

export const PlanFeatures = ({ type, _ }: FeaturesProps) => (
  <ul className="planFeatures">
    {(PLAN_FEATURES[type] || []).map((feature) => (
      <li key={feature} className={classNames({ inherited: feature.startsWith('everything_in') })}>
        <Icon iconName="done" size={18} />
        <span>{_(`label/feature/${feature}`)}</span>
      </li>
    ))}
  </ul>
);

export const PopularBadge = ({ _ }: { _: Function }) => (
  <span className="popularBadge">{_('label/most_popular')}</span>
);
